import React, { useState } from 'react'
import '../CSS/GiftGenerator.css';

const GiftGenerator = ({ closePopup, onRedeemCode, generatedCode, error }) => {
    const [amount, setAmount] = useState('');
    const [size, setSize] = useState('')

    async function redeemCode() {
        onRedeemCode(amount, size);
    }

    return (
        <div className='gift-screen'>
            <div className="gs-back" onClick={() => closePopup()}></div>
            <div className="gs-cover">
                <div className="gs-popup">
                    <div className="gs-title">Generate Code</div>
                    <div className="gs-input">
                        <span>&nbsp;Enter amount / person</span> <br />
                        <input type="text" placeholder='Enter amount per claim' value={amount} onChange={(e) => setAmount(e.target.value)} />
                    </div>

                    <div className="gs-input" style={{ marginTop: 10}}>
                        <span>&nbsp;Claim size</span> <br />
                        <input type="text" placeholder='Enter users amount can claim' value={size} onChange={(e) => setSize(e.target.value)} />
                    </div>

                    {generatedCode && <div className="gs-code">code: {generatedCode}</div>}
                    <div className="gs-code">{error.isError && error.message}</div>

                    <button className="confirm-btn" onClick={redeemCode}>Confirm</button>
                </div>
            </div>
        </div>
    )
}

export default GiftGenerator